import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { IndividualPayrocTerminalAccount } from './editPayrocTerminalAccount';

export interface AddPayrocTerminalAccountPayload {
  terminalId: string;
  payrocMerchantAccountId: number;
  storeId: number;
}

export const addPayrocTerminalAccount = ({
  terminalId,
  payrocMerchantAccountId,
  storeId,
}: AddPayrocTerminalAccountPayload): AxiosPromise<IndividualPayrocTerminalAccount> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/stores/${storeId}/payroc/terminals/add`,
    data: {
      terminalId,
      payrocMerchantAccountId,
    },
  });
};
